/**
 * ContentContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled content container.
 */
const ContentContainer = styled.div<React.CSSProperties>`
  left: 0;
  overflow: hidden;
  position: relative;
  top: 0;
  width: 100vw;
  z-index: 2;
`;

export default withOpacity(ContentContainer);
